import React from "react"

import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';


import { isNull, isEqual, isArray } from "lodash";

import {hasProperty, formatText, formatDate} from '../utils/utils';
import {cloneObject, getParam, truncate} from '../utils/utils';

import D3Graphviz from "../components/D3Graphviz";

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import ViewDataSpec from "../components/ViewDataSpec";
import ViewClass from "../components/ViewClass";
import ViewSerialization from "../components/ViewSerialization";
import Buffering from "../components/Buffering";

import { getDataSpecVersion, getSerializationVersion, getClassVersion, zipDataSpec} from "../utils/utilsDataSpec";


class ViewDataSpecVersion extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };


        this.handleControls = this.handleControls.bind(this);
        this.handleNavClick = this.handleNavClick.bind(this);
        this.handleExport = this.handleExport.bind(this);

        this.dsd = new dsd();
        this.dsd.StateObject = this;

    }

    componentDidMount(){

        this.setup();
 
     }

     componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props.params, prevProps.params)){
            this.setup();
        }

     }



    setup(){

        let StateChange = {
            idVersion: null,
            idDataSpec: null,
            type: null,
            DataSpec: null,
            isLoaded: false,
            isFailed: false, 

            Controls: {
            },


        }

        StateChange.idVersion = getParam('idVersion', this.props);
        StateChange.idDataSpec = getParam('idDataSpec', this.props);

        StateChange.isExporting = false;
        this.setState(StateChange);

        this.loadData(StateChange.idDataSpec, StateChange.idVersion);


    }

    loadData(id, idVersion){

        const onLoad = function(data){
            let StateChange = {};
            StateChange.DataSpec = data;
            StateChange.isLoaded = true;
            this.setState(StateChange);
            return;
        }.bind(this);

        var onFail = function(e){
            let StateChange = {};
            StateChange.DataSpec = null;
            StateChange.isFailed = true;

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);


        if (id){
            getDataSpecVersion(this.dsd, id, idVersion, onLoad, onFail);
        }

        return;
    }

    handleControls(event){

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let Controls = this.state.Controls;
        Controls[FormFieldName] = FormFieldValue;        
        this.setState({"Controls": Controls});

        return;

    }


    handleNavClick(event) {

        let idNode = null;

        if ("hash" in event.target){
            idNode = event.target.hash.substring(1);
        }
        else if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }

        if (idNode){
            const id = `${idNode}`
            const element = document.getElementById(id);
            if (element) {
              element.scrollIntoView({
                block: "start",
                behavior: "smooth",
              });
            }

        }

        event.preventDefault();

    };


    async handleExport(event){

        this.setState({isExporting: true});
        try {
            let DataSpec = cloneObject(this.state.DataSpec); 
            let Version = DataSpec.Version;
            let idDataSpec = this.state.idDataSpec;
            let idVersion = this.state.idVersion;
            let zipData = null;
            let link = null;

            zipData = await zipDataSpec(this.dsd, DataSpec);

            link = document.createElement("a");
            link.href = window.URL.createObjectURL(zipData);
            link.download = `dataspec_${idDataSpec}_version_${idVersion}.zip`;
            link.click();
        } finally {
            this.setState({isExporting: false});
        }

    }

    render() {

        if (this.state.isFailed){
            return <PD.ErrorBox>{this.state.errorMessage}</PD.ErrorBox>
        }

        if (this.state.isLoaded){
            return(
                <div>
                    <PD.Heading>{`Data Spec: ${this.state.DataSpec.name}`}</PD.Heading>
                    {this.state.DataSpec.Version &&
                        <>
                           {this.viewVersion(this.state.DataSpec.Version)}
                        </>
                    }
                    {this.viewDataSpec(this.state.DataSpec)}
                </div>
            )
        }
        return null;

    };    

    viewVersion(Version){

        if (Version){
            return(
                <fieldset>
                    <legend>Named Version</legend>
                    <PD.Table className="panel">
                        <PD.Tbody>                                

                            {hasProperty(Version,'name') &&
                                <PD.Tr>                                
                                    <PD.Th>Name</PD.Th><PD.Td>{Version.name}</PD.Td>
                                </PD.Tr>
                            }

                            {hasProperty(Version,'description') &&
                                <PD.Tr>
                                    <PD.Th>Description</PD.Th>
                                    <PD.Td>
                                        <PD.MdPresent>
                                            {Version.description}
                                        </PD.MdPresent>                                    
                                    </PD.Td>
                                </PD.Tr>
                            }

                            {hasProperty(Version,'createdAt') &&
                                <PD.Tr>
                                    <PD.Th>Date/Time</PD.Th><PD.Td>{formatDate(Version.createdAt,'dmy hms')}</PD.Td>
                                </PD.Tr>
                            }

                        </PD.Tbody>
                    </PD.Table>
                    <PD.Button onClick={this.handleExport} name="btnExport" value={this.state.isExporting ? "" : "export"}>
                        {this.state.isExporting && <Buffering/>}
                    </PD.Button>
                </fieldset>
                
            )
        };
        return null;
    };

    viewDataSpec(DataSpec){
        if (DataSpec){


            let countSerializations = 0;
            if (DataSpec.Serializations){
                if (DataSpec.Serializations.length){
                    countSerializations = DataSpec.Serializations.length;
                }
            }

            let countClasses = 0;
            if (DataSpec.Classes){
                if (DataSpec.Classes.length){
                    countClasses = DataSpec.Classes.length;
                }
            }

            let vizoptions = {}
            vizoptions.engine = 'dot';
            vizoptions.fit = false;
            vizoptions.width = null;
            vizoptions.height = null;
            vizoptions.zoom = false;
            vizoptions.scale = 1;

            let styleDiv = {}

            return(
                <div>
                    <ViewDataSpec DataSpec={DataSpec} noLinks/>

                    <PD.Heading level="2">Index</PD.Heading>

                    {countSerializations &&
                        <fieldset>
                            <legend>Serializations</legend>
                            <PD.Table className="list">
                                <PD.Thead>
                                    <PD.Tr>
                                        <PD.Th>Name</PD.Th>
                                        <PD.Th>Description</PD.Th>
                                    </PD.Tr>
                                </PD.Thead>
                                <PD.Tbody>
                                    {
                                        DataSpec.Serializations.map(
                                            (Serialization, pos) => 
                                            {                
                                                switch (Serialization.status){
                                                    case 'deprecated': return null;
                                                    default:

                                                        return (

                                                            <PD.Tr key={pos}>
                                                                <PD.Td>
                                                                    <PD.PdNavLink to={`#serialization_${Serialization._id}`} onClick={this.handleNavClick}>{Serialization.name}</PD.PdNavLink>
                                                                </PD.Td>
                                                                <PD.Td>
                                                                    <PD.MdPresent>{truncate(Serialization.description, 400)}</PD.MdPresent>
                                                                </PD.Td>
                                                            </PD.Tr>
                                                        )
                                                }
                                            }
                                    
                                        )
                                    }
                                </PD.Tbody>
                            </PD.Table>
                        </fieldset>
                    }

                    {countClasses &&
                        <fieldset>
                            <legend>Classes</legend>
                            <PD.Table className="list">
                                <PD.Thead>
                                    <PD.Tr>
                                        <PD.Th>Name</PD.Th>
                                        <PD.Th>Description</PD.Th>
                                    </PD.Tr>
                                </PD.Thead>
                                <PD.Tbody>
                                    {
                                        DataSpec.Classes.map(
                                            (Class, pos) => 
                                            {                
                                                switch (Class.status){
                                                    case 'deprecated': return null;
                                                    default:

                                                        return (

                                                            <PD.Tr key={pos}>
                                                                <PD.Td>
                                                                    <PD.PdNavLink to={`#class_${Class._id}`} onClick={this.handleNavClick}>{Class.name}</PD.PdNavLink>
                                                                </PD.Td>
                                                                <PD.Td>
                                                                    <PD.MdPresent>{truncate(Class.description, 400)}</PD.MdPresent>
                                                                </PD.Td>
                                                            </PD.Tr>
                                                        )
                                                }
                                            }
                                    
                                        )
                                    }
                                </PD.Tbody>
                            </PD.Table>
                        </fieldset>
                    }


                    {
                        countSerializations &&
                            <div>
                                <PD.Heading level="2">Serializations</PD.Heading>
                                {
                                    DataSpec.Serializations.map(
                                        (Serialization, pos) =>    
                                        {
                                            
                                            switch (Serialization.status){
                                                case 'deprecated': return null;
                                                default:

                                                    return (
                                                        <fieldset key={pos} id={`serialization_${Serialization._id}`}>
                                                            <ViewSerialization Serialization={Serialization} noLinks/>

                                                            <fieldset>
                                                                <legend>visualisation</legend>
                                                                <ViewSerializationImage dsd={this.dsd} idSerialization={Serialization._id} idVersion={this.state.idVersion}/>                                                                
                                                            </fieldset>

                                                            <PD.Heading level="3">Renditions</PD.Heading>
                                                            <fieldset>
                                                                <legend>json schema</legend>
                                                                <pre>
                                                                    <ViewSerializationJsonSchema dsd={this.dsd} idSerialization={Serialization._id} idVersion={this.state.idVersion}/>                                                                
                                                                </pre>
                                                            </fieldset>
                                                            <fieldset>
                                                                <legend>XML Schema</legend>
                                                                <pre>
                                                                    <ViewSerializationXSD dsd={this.dsd} idSerialization={Serialization._id} idVersion={this.state.idVersion}/>                                                                
                                                                </pre>
                                                            </fieldset>

                                                        </fieldset>
                                                    )
                                            }
                                        }
                                    )
                                }
                            </div>
                    }


                    {
                        countClasses &&
                            <div>
                                <PD.Heading level="2">Classes</PD.Heading>
                                {
                                    DataSpec.Classes.map(
                                        (Class, pos) =>    
                                        {
                                            
                                            switch (Class.status){
                                                case 'deprecated': return null;
                                                default:

                                                    return (
                                                        <fieldset key={pos} id={`class_${Class._id}`}>
                                                            <ViewClass key={pos} Class={Class} noLinks/>
                                                            <fieldset>
                                                                <legend>visualisation</legend>
                                                                <ViewClassImage dsd={this.dsd} idClass={Class._id} idVersion={this.state.idVersion}/>                                                                
                                                            </fieldset>
                                                        </fieldset>
                                                    )
                                            }
                                        }
                                    )
                                }
                            </div>
                    }

                </div>
            )
        }
    }
 
};

class ViewClassImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };
    }

    componentDidMount(){
        this.setup(); 
    }

    setup(){

        let StateChange = {
            idVersion: null,
            idClass: null,
            isLoaded: false,
            isFailed: false, 
            dot: null
        }

        const dsd = getParam('dsd', this.props);
        StateChange.idVersion = getParam('idVersion', this.props);
        StateChange.idClass = getParam('idClass', this.props);
        if (StateChange.idClass){

            const onLoad = function(data){
                let StateChange = {};
                StateChange.dot = data;
                StateChange.isLoaded = true;
                this.setState(StateChange);
                return;
            }.bind(this);
    
            var onFail = function(e){
                let StateChange = {};
                StateChange.dot = null;
                StateChange.isFailed = true;
    
                StateChange.errorMessage = e.message;    
                if (e.response){
                    if (e.response.data){
                        if (e.response.data.message){
                            StateChange.errorMessage = e.response.data.message;
                        }
                    }
                }
                this.setState(StateChange);
                return;
            }.bind(this);

            getClassVersion(dsd,StateChange.idClass,StateChange.idVersion, onLoad, onFail,'dot')
        }

        this.setState(StateChange);

    }

    handleNavClick(event) {

        let idNode = null;

        if ("hash" in event.target){
            idNode = event.target.hash.substring(1);
        }
        else if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }

        if (idNode){
            const id = `${idNode}`
            const element = document.getElementById(id);
            if (element) {
              element.scrollIntoView({
                block: "start",
                behavior: "smooth",
              });
            }

        }

        event.preventDefault();

    };

    render(){
        if (this.state.isLoaded){
            return(
                <D3Graphviz dot={this.state.dot} onClick={this.handleNavClick}/>
            )
        }
        return <div/>
    }

};



class ViewSerializationImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };
    }

    componentDidMount(){
        this.setup(); 
    }

    setup(){

        let StateChange = {
            idVersion: null,
            idSerialization: null,
            isLoaded: false,
            isFailed: false, 
            dot: null
        }

        const dsd = getParam('dsd', this.props);
        StateChange.idVersion = getParam('idVersion', this.props);
        StateChange.idSerialization = getParam('idSerialization', this.props);
        if (StateChange.idSerialization){

            const onLoad = function(data){
                let StateChange = {};
                StateChange.dot = data;
                StateChange.isLoaded = true;
                this.setState(StateChange);
                return;
            }.bind(this);
    
            var onFail = function(e){
                let StateChange = {};
                StateChange.dot = null;
                StateChange.isFailed = true;
    
                StateChange.errorMessage = e.message;    
                if (e.response){
                    if (e.response.data){
                        if (e.response.data.message){
                            StateChange.errorMessage = e.response.data.message;
                        }
                    }
                }
                this.setState(StateChange);
                return;
            }.bind(this);

            getSerializationVersion(dsd,StateChange.idSerialization,StateChange.idVersion, onLoad, onFail,'dot')
        }

        this.setState(StateChange);

    }

    handleNavClick(event) {

        let idNode = null;

        if ("hash" in event.target){
            idNode = event.target.hash.substring(1);
        }
        else if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }

        if (idNode){
            const id = `${idNode}`
            const element = document.getElementById(id);
            if (element) {
              element.scrollIntoView({
                block: "start",
                behavior: "smooth",
              });
            }

        }

        event.preventDefault();

    };

    render(){
        if (this.state.isLoaded){
            return(
                <D3Graphviz dot={this.state.dot} onClick={this.handleNavClick}/>
            )
        }
        return <div/>
    }

};


class ViewSerializationJsonSchema extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };
    }

    componentDidMount(){
        this.setup(); 
    }

    setup(){

        let StateChange = {
            idVersion: null,
            idSerialization: null,
            isLoaded: false,
            isFailed: false, 
            Schema: null
        }

        const dsd = getParam('dsd', this.props);
        StateChange.idVersion = getParam('idVersion', this.props);
        StateChange.idSerialization = getParam('idSerialization', this.props);
        if (StateChange.idSerialization){

            const onLoad = function(data){
                let StateChange = {};
                StateChange.Schema = data;
                StateChange.isLoaded = true;
                this.setState(StateChange);
                return;
            }.bind(this);
    
            var onFail = function(e){
                let StateChange = {};
                StateChange.Schema = null;
                StateChange.isFailed = true;
    
                StateChange.errorMessage = e.message;    
                if (e.response){
                    if (e.response.data){
                        if (e.response.data.message){
                            StateChange.errorMessage = e.response.data.message;
                        }
                    }
                }
                this.setState(StateChange);
                return;
            }.bind(this);

            getSerializationVersion(dsd,StateChange.idSerialization,StateChange.idVersion, onLoad, onFail,'jsonschema')
        }

        this.setState(StateChange);

    }

    render(){
        if (this.state.isLoaded){
            return(
                JSON.stringify(this.state.Schema, null, "\t")
            )
        }
        return <div/>
    }

};


class ViewSerializationXSD extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };
    }

    componentDidMount(){
        this.setup(); 
    }

    setup(){

        let StateChange = {
            idVersion: null,
            idSerialization: null,
            isLoaded: false,
            isFailed: false, 
            Schema: null
        }

        const dsd = getParam('dsd', this.props);
        StateChange.idVersion = getParam('idVersion', this.props);
        StateChange.idSerialization = getParam('idSerialization', this.props);
        if (StateChange.idSerialization){

            const onLoad = function(data){
                let StateChange = {};
                StateChange.Schema = data;
                StateChange.isLoaded = true;
                this.setState(StateChange);
                return;
            }.bind(this);
    
            var onFail = function(e){
                let StateChange = {};
                StateChange.Schema = null;
                StateChange.isFailed = true;
    
                StateChange.errorMessage = e.message;    
                if (e.response){
                    if (e.response.data){
                        if (e.response.data.message){
                            StateChange.errorMessage = e.response.data.message;
                        }
                    }
                }
                this.setState(StateChange);
                return;
            }.bind(this);

            getSerializationVersion(dsd,StateChange.idSerialization,StateChange.idVersion, onLoad, onFail,'XSD')
        }

        this.setState(StateChange);

    }

    render(){
        if (this.state.isLoaded){
            return(
                this.state.Schema.toString()
            )
        }
        return <div/>
    }

};

        
export default function ViewDataSpecVersion_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ViewDataSpecVersion {...props} navigation={navigation} location={location} params={params} />;
  }
